/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_102Inputs */

const cs_ares_legal_form_102 = /** @type {(inputs: Ares_Legal_Form_102Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyzická osoba podnikající dle jiných zákonů`)
};

const en_ares_legal_form_102 = /** @type {(inputs: Ares_Legal_Form_102Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural person (other statute)`)
};

/**
* | output |
* | --- |
* | "Natural person (other statute)" |
*
* @param {Ares_Legal_Form_102Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_102 = /** @type {((inputs?: Ares_Legal_Form_102Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_102Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_102(inputs)
	return cs_ares_legal_form_102(inputs)
});